import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {useParams} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {Container} from '@material-ui/core';
import ShipmentDetailsCard from "./ShipmentDetailsCard";
import ParticipantsExpansionPanel from './ParticipantsExpansionPanel';
import ShipmentDetailsExpansionPanel from './ShipmentDetailsExpansionPanel';
import {getShipmentInfo} from "../../api/ShipmentEndpoint";
import {RR_STATUS} from "../../constants/RRConstants";
import {useSnackbar} from "notistack";
import {useTranslation} from "react-i18next";
import DocumentsExpansionPanel from './DocumentsExpansionPanel';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1
        }
    })
);

interface SingleShipmentDetailsProps {
    setShipment: (setShipment: any) => void
}

export const SingleShipmentDetailsComponents = ({ setShipment }: SingleShipmentDetailsProps) => {
    const classes = useStyles();
    const {enqueueSnackbar} = useSnackbar();
    const {t} = useTranslation();
    const {uuid} = useParams<{ uuid: string }>();

    React.useEffect(() => {
        if (!uuid) return;

        getShipmentInfo(uuid).then(({data}) => {
            const {status, response} = data;

            if (status !== RR_STATUS.OK) {
                enqueueSnackbar(t("core.server-error"), {
                    variant: "error",
                    preventDuplicate: false
                });
            } else {
                setShipment(response);
            }
        })
    }, [enqueueSnackbar, t, setShipment, uuid]);

    if (!uuid) return null;

    return (<div className={classes.root}>
            <Container>
                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <ShipmentDetailsCard uuid={uuid}/>
                    </Grid>
                    <Grid item xs={12}>
                        <ParticipantsExpansionPanel uuid={uuid}/>
                    </Grid>

                    <Grid item xs={12}>
                        <ShipmentDetailsExpansionPanel uuid={uuid}/>
                    </Grid>
                    <Grid item xs={12}>
                        <DocumentsExpansionPanel uuid={uuid}/>
                    </Grid>
                </Grid>

            </Container>


        </div>
    );
};

export default SingleShipmentDetailsComponents;
